<div class="events">
    <div class="header">
        <H2> DISPLAY OUR EVENTS </H2>
    </div>

    <div class="searchbar">
        <div class="search-bar">
            <div class="ikon">
                <img src="/assets/images/search-icon.svg" alt="search icon" />
            </div>
            <input type="text" placeholder="Search events" #input (keyup)="filterevents(input.value)" />


        </div>
    </div>

    <div class="eventlist custom-scroll scroll-small" *ngIf="events">
        <div class="eachevent" *ngFor="let event of events " (click)=routepage(event)>
            <div class="img">
                <img class="img" *ngIf="event.coverImage" src="{{event.coverImage}}" alt="event-logo-image">

            </div>
            <div class="details">
                <div class="name" *ngIf="event.name">{{event.name}}</div>
                <div class="loc" *ngIf="event.locationAddress">
                    <div>
                        <img src="assets/images/location-icon-small.svg" alt="">
                    </div>
                    <div>
                        <!-- {{stripLocation(event)}} -->
                        {{event.locationAddress}}
                    </div>
                </div>
                <div class="date" *ngIf="event.startTime && event.endTime ">
                    <div>
                        <img src="assets/images/calendar-icon.svg" alt="">
                    </div>
                    <div>
                        {{loadDate(event)}}
                    </div>
                </div>
                <div class="organized" *ngIf="event.author">
                    <div></div>
                    <div>
                        Organized by
                        {{event.author}}
                    </div>
                </div>
            </div>
        </div>

    </div>
    <div class="noevents" *ngIf="!events || events?.length == 0"> No events to display </div>
</div>